import { render, staticRenderFns } from "./v-radio-group.vue?vue&type=template&id=653d6c8a&scoped=true&"
import script from "./v-radio-group.vue?vue&type=script&lang=js&"
export * from "./v-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./v-radio-group.vue?vue&type=style&index=0&id=653d6c8a&lang=scss&scoped=true&"
import style1 from "./v-radio-group.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d6c8a",
  null
  
)

export default component.exports